export type SearchParamsType = {
  pageNumber: number;
  pageSize: number;
  searchText: string;
  sortField: string;
  sortOrder: string;
  status: number;
};

export type MasterTableDataType = {
  hpiComName: string;
  hpiComCode: string;
  clinicId: number;
  hpiName: string;
  hpiStatus: number;
  hpiComId: number;
  hpiId: number;
  hpiCode: string;
};

export type MasterDataType = {
  clinicId: number;
  hpiCode: string;
  hpiCreatedByDate: string;
  hpiName: string;
  hpiStatus: number;
  hpiId: number;
  hpiCreatedById: number;
  hpiComId: number;
};

export type HPIComponentType = {
  hpiComId: number;
  hpiComCode: string;
  hpiComName: string;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  hpiCode: string;
  hpiName: string;
  hpiStatus: number;
  hpiComponent: HPIComponentType | null;
};

export const initialFormData: MasterFormDataType = {
  hpiCode: "",
  hpiName: "",
  hpiStatus: 1,
  hpiComponent:null,
};
